import React, { useState, useEffect } from 'react';

export default function Contact() {
  const [info, setInfo] = useState({
    address: 'Betöltés...',
    phone1: '',
    phone2: '',
    email1: '',
    email2: '',
    open_time: '08:00',
    close_time: '16:00'
  });

  useEffect(() => {
    // Adatok lekérése a backendről
    fetch(`/api/shop-info`)
      .then(res => res.json())
      .then(data => {
        if (data) setInfo(data);
      })
      .catch(err => {
        console.error("Hiba az adatok betöltésekor:", err);
        setInfo({
          address: "Hiba az adatok betöltésekor",
          phone1: "",
          phone2: "",
          email1: "",
          email2: "",
          open_time: "",
          close_time: ""
        });
      });
  }, []);

  return (
    <div className="min-h-screen bg-transparent text-gray-900 dark:text-white transition-colors duration-300">
      <div className="max-w-7xl mx-auto py-12 px-4">
        {/* Fejléc */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-6xl font-black text-[#a855f7] mb-4 uppercase tracking-tighter leading-tight">
            Kapcsolat
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
          {/* Adatok rész*/}
          <div className="bg-slate-100/5 dark:bg-slate-800/60 rounded-[1.0rem] p-5 sm:p-12 shadow-lg border border-slate-300/90 dark:border-slate-700/90 flex flex-col justify-center transition-all duration-300">
            <div className="space-y-8 sm:space-y-12">
              
              {/* Helyszín rész */}
              <section>
                <h3 className="text-purple-600 dark:text-purple-400 font-black uppercase tracking-widest text-xs mb-3">
                  Helyszín
                </h3>
                <p className="text-2xl sm:text-4xl font-black text-gray-900 dark:text-white not-italic tracking-tight break-words">
                  {info.address}
                </p>
              </section>

              {/* Nyitvatartás rész */}
              <section>
                <h3 className="text-purple-600 dark:text-purple-400 font-black uppercase tracking-widest text-xs mb-3">
                  Nyitvatartás
                </h3>
                <p className="text-2xl sm:text-3xl font-black text-gray-900 dark:text-white not-italic tracking-tight">
                  {info.open_time} - {info.close_time}
                </p>
              </section>
              
              {/* Telefonok rész */}
              <section>
                <h3 className="text-purple-600 dark:text-purple-400 font-black uppercase tracking-widest text-xs mb-3">
                  Telefonálj nekünk
                </h3>
                <div className="space-y-2">
                    <p className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white not-italic tracking-tighter break-words">
                    {info.phone1}
                  </p>
                  <p className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white not-italic tracking-tighter break-words">
                    {info.phone2}
                  </p>
                </div>
              </section>

              {/* E-mailek rész */}
              <section>
                <h3 className="text-purple-600 dark:text-purple-400 font-black uppercase tracking-widest text-xs mb-3">
                  Írj nekünk
                </h3>
                <div className="space-y-2">
                  <p className="text-2xl font-bold text-gray-700 dark:text-gray-300 not-italic break-all tracking-tight">
                    {info.email1}
                  </p>
                  <p className="text-2xl font-bold text-gray-700 dark:text-gray-300 not-italic break-all tracking-tight">
                    {info.email2}
                  </p>
                </div>
              </section>

            </div>
          </div>

          {/* Google Maps rész */}
          <div className="bg-gray-200 rounded-[1.0rem] overflow-hidden shadow-2xl border-4 border-white h-[500px] lg:h-auto relative group">
            {info.address && (
              <iframe
                title="Fodrász"
                width="100%" 
                height="100%" 
                frameBorder="0" 
                style={{ border: 0 }}
                src={`https://www.google.com/maps?q=${encodeURIComponent(info.address)}&output=embed`}
                allowFullScreen
              ></iframe>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}